<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span>Заголовок (<TranslationIcon/>)</span>
        <v-text-field
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.title"
          :error-messages="errorMessages.title"
          @input="mixChangeListItemHandler($event, 'title')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <span>Подзаголовок (<TranslationIcon/>)</span>
        <v-text-field
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.subTitle"
          @input="mixChangeListItemHandler($event, 'subTitle')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Заголовок кнопки (<TranslationIcon/>)</span>
        <v-text-field
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.buttonTitle"
          @input="mixChangeListItemHandler($event, 'buttonTitle')"
        />
      </v-col>
      <v-col cols="6">
        <span>URL кнопки</span>
        <v-text-field
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.buttonLink"
          @input="mixChangeListItemHandler($event, 'buttonLink')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'
import TranslationIcon from '@/components/translation-icon/translationIcon'
export default {
  name: 'HeadingWidget',
  components: { TranslationIcon },
  mixins: [dynamicListItemMix]
}
</script>
